import { FetchClient } from "../utils/fetchClient";

export async function getConfigMessageFromSectionId(sectionId = 0) {
    return await FetchClient(`/jobs/config-message?section_id=${sectionId}`).GET({})
}

export async function updateConfigMessage(id = 0, updateRequest) {
    return await FetchClient(`/jobs/config-message?id=${id}`).PUT({ payload: JSON.stringify(updateRequest) })
}